import { useState, useEffect } from 'react'
import { useParams, Link } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export default function PreviewPage() {
  const { token } = useParams()
  const [post, setPost] = useState(null)
  const [loading, setLoading] = useState(true)
  const [notFound, setNotFound] = useState(false)

  useEffect(() => {
    supabase.from('posts')
      .select('*, profiles!posts_author_id_fkey(display_name)')
      .eq('share_token', token)
      .single()
      .then(({ data, error }) => {
        if (error || !data) { setNotFound(true); setLoading(false); return }
        setPost(data)
        setLoading(false)
      })
  }, [token])

  if (loading) return (
    <div style={styles.page}>
      <p style={styles.loading}>Loading preview…</p>
    </div>
  )

  if (notFound) return (
    <div style={styles.page}>
      <div style={styles.notFound}>
        <p style={styles.eyebrow}>Preview not found</p>
        <h1 style={styles.title}>This draft link has expired or doesn't exist.</h1>
        <Link to="/" className="btn btn-ink" style={{ marginTop: '1.5rem', display: 'inline-flex' }}>Go home</Link>
      </div>
    </div>
  )

  const isHtml = post.body?.includes('<')

  return (
    <div style={styles.page}>
      <div style={styles.banner}>
        <span style={styles.bannerText}>◈ Draft preview — not published</span>
        <Link to="/" style={styles.bannerLink}>← The Margins</Link>
      </div>
      <div style={styles.content}>
        <p style={styles.eyebrow}>{post.tag || post.section}</p>
        <h1 style={styles.title}>{post.title}</h1>
        {post.excerpt && <p style={styles.excerpt}>{post.excerpt}</p>}
        <div style={styles.meta}>
          <span>{post.profiles?.display_name}</span>
          {post.read_time && <span>{post.read_time} min read</span>}
        </div>
        {post.cover_image && (
          <img src={post.cover_image} alt={post.title} style={styles.coverImg} />
        )}
        <div style={styles.body} className="post-body">
          {isHtml
            ? <div dangerouslySetInnerHTML={{ __html: post.body }} />
            : post.body.split('\n\n').map((p, i) => <p key={i}>{p}</p>)
          }
        </div>
      </div>
    </div>
  )
}

const styles = {
  page: { paddingTop: '4.5rem', minHeight: '100vh' },
  loading: { padding: '6rem 3rem', fontFamily: "'DM Mono', monospace", fontSize: '0.75rem', color: 'var(--muted)' },
  banner: {
    background: 'var(--accent)', color: '#fff',
    padding: '0.6rem 2rem', display: 'flex',
    justifyContent: 'space-between', alignItems: 'center',
  },
  bannerText: { fontFamily: "'DM Mono', monospace", fontSize: '0.62rem', letterSpacing: '0.1em' },
  bannerLink: { fontFamily: "'DM Mono', monospace", fontSize: '0.62rem', color: '#fff', letterSpacing: '0.08em' },
  content: { maxWidth: 720, margin: '0 auto', padding: '4rem 2rem 6rem' },
  eyebrow: { fontFamily: "'DM Mono', monospace", fontSize: '0.62rem', letterSpacing: '0.16em', textTransform: 'uppercase', color: 'var(--accent)', marginBottom: '1rem' },
  title: { fontFamily: "'Space Grotesk', sans-serif", fontSize: 'clamp(2rem, 4vw, 3rem)', fontWeight: 700, letterSpacing: '-0.02em', marginBottom: '1rem', lineHeight: 1.1 },
  excerpt: { fontFamily: "'Space Grotesk', sans-serif", fontStyle: 'italic', fontSize: '1.1rem', color: 'var(--muted)', lineHeight: 1.7, marginBottom: '1.5rem' },
  meta: { fontFamily: "'DM Mono', monospace", fontSize: '0.62rem', color: 'var(--muted)', display: 'flex', gap: '1.5rem', paddingBottom: '2rem', borderBottom: '1px solid var(--rule)', marginBottom: '2rem' },
  coverImg: { width: '100%', maxHeight: 420, objectFit: 'cover', marginBottom: '2rem', display: 'block' },
  body: { fontSize: '1.05rem', lineHeight: 1.85 },
  notFound: { maxWidth: 500, margin: '8rem auto', textAlign: 'center', padding: '0 2rem' },
}
